import {
	GET_CONTACTS_LIST,
	GET_CONTACTS_LIST_SUCCESS,
	SET_UPLOAD_CONTACTS_OPEN,
	UPLOAD_CONTACTS,
	UPLOAD_CONTACTS_SUCCESS,
	SET_IS_UPLOAD_FALSE,
	CHANGE_CONTACTS_LIST,
	MULTIPLE_STAR_CONTACTS,
	MULTIPLE_UNSTAR_CONTACTS,
	MULTIPLE_HIDE_CONTACTS,
	MULTIPLE_UNHIDE_CONTACTS,
	MULTIPLE_UNSUBSCRIBE_CONTACTS,
	CHECK_EMAIL_UNSUBSCRIBE,
	CHECK_EMAIL_UNSUBSCRIBE_SUCCESS,
	SAVE_CONTACTS,
	SAVE_CONTACTS_SIMPLE,
	SAVE_CONTACTS_SIMPLE_SUCCESS,
	DELETE_CONTACTS,
	GET_IMPORTED_CONTACTS,
	GET_IMPORTED_CONTACTS_SUCCESS,
	GET_SUGGESTED_CONTACTS,
	GET_SUGGESTED_CONTACTS_SUCCESS,
	GET_CONTACTS_DETAILS,
	GET_CONTACTS_DETAILS_SUCCESS,
	GET_CONTACTS_DETAIL_LIST,
	GET_CONTACTS_DETAIL_LIST_SUCCESS,
	GET_CONTACTS_MEMO,
	GET_CONTACTS_MEMO_SUCCESS,
	CHANGE_CONTACTS_DETAILS,
	SAVE_MEMO,
	SAVE_MEMO_SUCCESS,
	CHANGE_IMPORTED_CONTACTS,
	CHANGE_SUGGESTED_CONTACTS,
	CHANGE_MEMBER_CONFIRMED_CONTACTS,
	GET_CONTACTS_SETTINGS,
	GET_CONTACTS_SETTINGS_SUCCESS,
	DOWN_CONTACTS_EXCEL,
	DOWN_CONTACTS_EXCEL_SUCCESS,
	SET_SEARCH_SETTINGS,
	SET_CONTACS_RESULT,
	SET_CONTACS_DETAIL_RESULT,
	SET_CONTACS_LOADING,

	GET_UPLOADED_CONTACTS_LIST,
	GET_UPLOADED_CONTACTS_LIST_SUCCESS,
	SAVE_UPLOADED_CONTACTS,
	DELETE_UPLOADED_CONTACTS,
	DOWN_UPLOADED_CONTACTS_EXCEL,
	DOWN_UPLOADED_CONTACTS_EXCEL_SUCCESS,
	CHANGE_UPLOADED_CONTACTS_LIST,

	GET_DOMAIN_CORRECT_YN_COUNT,
	GET_DOMAIN_CORRECT_YN_COUNT_SUCCESS,
	SAVE_DOMAIN_CORRECT_YN,
	SAVE_DOMAIN_CORRECT_YN_SUCCESS,
	CHANGE_USER_SUGGEST_DOMAIN,
	CHANGE_SHOW_SUCCESS_ADD_TOAST_FLAG,
	CHANGE_CHECK_UNSUBS_EMAIL_ADDRESS_FLAG,

	GET_CONTACT_SEARCH_LIST,
	GET_CONTACT_SEARCH_LIST_SUCCESS,
	CHANGE_CONTACT_SEARCH_LIST,
	DOWN_SEARCH_ENTITY_EXCEL,
	DOWN_SEARCH_ENTITY_EXCEL_SUCCESS,
	DISABLE_CONTACTS_SEND_YN,
	ENABLE_CONTACTS_SEND_YN,
	SET_SUGGESTED_CONTACTS_ACTIVE,
	SET_SUGGESTED_CONTACTS_TOTAL_PAGE,
	DELETE_UPLOADED_CONTACTS_BY_FILE,
	STAR_HIDE_SUCCESS,
} from "./actionTypes";

import Diacritics from 'diacritic'

const initialState = {
	error: "",
	loading: false,
	contactSearchLoading: false,
	noticeStr: "",
	noticeStrUp: "",
	contactsList: [],
	uploadContactsOpen: false,
	successCnt: 0,
	duplicateWithinFileCnt: 0,
	duplicateInSystemCnt: 0,
	failCnt: 0,
	totalProcessedCnt: 0,
	invalidCountries: [],
	invalidEmails: [],
	isUpload: false,
	isSearched: false,
	importedContacts: [],
	importedTotalPage: 1,
	suggestedContacts: [],
	suggestedContactsActive: [],
	suggestedTotalPage: 1,
	suggestedPerPage: 10,
	suggestedContactsExist: false,
	contactsDetails: {},
	memo: {},
	searchSettings: {},
	result: -1,
	totalPage: 1,
	uploadedContactsList: [],
	uploadContactsHistory: [],
	totalPageUp: 1,
	domainCorrectYnCount: {},
	userSuggestDomain: {},
	userGrade: "00",
	showSuccessAddToastFlag: false,
	unsubsEmailAddress1: "",
	unsubsEmailAddress2: "",
	checkUnsubsEmailAddressFlag: false,
	toastMessage: "",
	saveType: "",
	screenName: "",
	searchList: [],
	totalPageSearch: 1,
	detailResult: -1,
	memberConfirmedContacts: [],
}

const contacts = (state = initialState, action) => {
	switch (action.type) {
		case GET_CONTACTS_LIST:
			return {
				...state,
				loading: true
			}
		case GET_CONTACTS_LIST_SUCCESS:
			return {
				...state,
				noticeStr: action.payload.noticeStr,
				contactsList: action.payload.contactsList,
				totalPage: action.payload.totalPage,
				isSearched: true,
				loading: false
			}
		case SET_UPLOAD_CONTACTS_OPEN:
			return {
				...state,
				uploadContactsOpen: action.payload,
				isUpload: action.payload === false ? false : state.isUpload,
			}
		case UPLOAD_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case UPLOAD_CONTACTS_SUCCESS:
			return {
				...state,
				successCnt: action.payload.successCnt,
				duplicateWithinFileCnt: action.payload.duplicateWithinFileCnt,
				duplicateInSystemCnt: action.payload.duplicateInSystemCnt,
				failCnt: action.payload.failCnt,
				invalidEmails: action.payload.invalidEmails,
				invalidCountries: action.payload.invalidCountries,
				totalProcessedCnt: action.payload.totalCnt,
				isUpload: true,
				loading: false,
			}
		case SET_IS_UPLOAD_FALSE:
			return {
				...state,
				successCnt: 0,
				duplicateCnt: 0,
				failCnt: 0,
				isUpload: false,
			}
		case CHANGE_CONTACTS_LIST:
			return {
				...state,
				contactsList: action.payload,
			}
		case MULTIPLE_STAR_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case MULTIPLE_UNSTAR_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case MULTIPLE_HIDE_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case MULTIPLE_UNHIDE_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case STAR_HIDE_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case MULTIPLE_UNSUBSCRIBE_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case CHECK_EMAIL_UNSUBSCRIBE:
			return {
				...state,
				loading: true,
				saveType: action.payload.saveType,
				screenName: action.payload.screenName,
			}
		case CHECK_EMAIL_UNSUBSCRIBE_SUCCESS:
			if (action.payload.screenName == 'List') {
				return {
					...state,
					loading: false,
					unsubsEmailAddress1: action.payload.data.result == '0' ? "" : action.payload.data.unsubsEmailList1,
					unsubsEmailAddress2: action.payload.data.result == '0' ? "" : action.payload.data.unsubsEmailList2,
					result: action.payload.data.result == '0' ? -1  :
							action.payload.data.unsubsEmailList1.length > 2 ? 8 :
								action.payload.data.unsubsEmailList2.length > 2 ? 16 : -1,
					checkUnsubsEmailAddressFlag: action.payload.data.result == '0' ? true : false,
				}
			} else {
				return {
					...state,
					loading: false,
					unsubsEmailAddress1: action.payload.data.result == '0' ? "" : action.payload.data.unsubsEmailList1,
					unsubsEmailAddress2: action.payload.data.result == '0' ? "" : action.payload.data.unsubsEmailList2,
					detailResult: 
						action.payload.data.result == '0' ? -1  :
							action.payload.data.unsubsEmailList1.length > 2 ? 10 :
								action.payload.data.unsubsEmailList2.length > 2 ? 12 : -1,
					checkUnsubsEmailAddressFlag: action.payload.data.result == '0' ? true : false,
				}
			}
		case SAVE_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case SAVE_CONTACTS_SIMPLE:
			return {
				...state,
				loading: true,
			}
		case SAVE_CONTACTS_SIMPLE_SUCCESS:
			return {
				...state,
				loading: false,
				contactsDetails: action.payload.contactsDetails,
				showSuccessAddToastFlag: true,
				toastMessage: "Add contacts!"
			}
		case DELETE_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case GET_IMPORTED_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case GET_IMPORTED_CONTACTS_SUCCESS:
			return {
				...state,
				importedContacts: action.payload.uploadedContactsList,
				importedTotalPage: action.payload.totalPageUp,
				uploadContactsHistory: action.payload.uploadHistory,
				loading: false,
			}
		case GET_SUGGESTED_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case GET_SUGGESTED_CONTACTS_SUCCESS:
			return {
				...state,
				suggestedContacts: rankSuggestedContacts({
					entityName: state.contactsDetails?.targetGroupName,
					country: Array.of(
						...new Set(state?.contactsDetails?.contactsDetailList?.map(detail => detail.country)),
						...new Set(action.payload?.targetGroupAddressList?.map(detail => detail.country))
					),
					address: action.payload?.targetGroupAddressList?.map(detail => detail.address).join("+")
				},
					action.payload.suggestedContacts
				),
				suggestedTotalPage: action.payload.suggestedTotalPage,
				loading: false,
			}
		case SET_SUGGESTED_CONTACTS_ACTIVE:
			return {
				...state,
				suggestedContactsActive: action.payload
			}
		case SET_SUGGESTED_CONTACTS_TOTAL_PAGE:
			return {
				...state,
				suggestedTotalPage: action.payload
			}
		case GET_CONTACTS_DETAILS:
			return {
				...state,
				contactsDetails: {},
				memo: {},
				suggestedContacts: [],
				suggestedContactsActive: [],
				suggestedTotalPage: 1,
				importedContacts: [],
				importedTotalPage: 1,
				domainCorrectYnCount: {},
				userSuggestDomain: {},
				loading: true,
			}
		case GET_CONTACTS_DETAILS_SUCCESS:

			const _suggestedContacts = rankSuggestedContacts(
				{
					entityName: action.payload?.contactsDetails?.targetGroupName,
					country: action.payload.targetGroupCountry ? [action.payload.targetGroupCountry] : Array.of(
						...new Set(action.payload?.contactsDetails?.contactsDetailList?.map(detail => detail.country)),
						...new Set(action.payload?.targetGroupAddressList?.map(detail => detail.country))
					),
					address: action.payload.targetGroupAddress 
					 ? action.payload.targetGroupAddress
					 : action.payload?.targetGroupAddressList
					 	?.map(detail => detail.address).join("+"),
					field: action.payload?.field ? action.payload.field : "",
				},
				action.payload.suggestedContacts
			)
			const _suggestedContactsActive = _suggestedContacts.slice(0, 10)

			return {
				...state,
				contactsDetails: action.payload.contactsDetails,
				memo: action.payload.memo,
				suggestedContacts: _suggestedContacts,
				suggestedContactsActive: _suggestedContactsActive,
				suggestedTotalPage: action.payload.suggestedTotalPage,
				suggestedContactsExist: action.payload.suggestedContacts && action.payload.suggestedContacts.length > 0 ? true : false,
				importedContacts: action.payload.importedContacts,
				importedTotalPage: action.payload.totalPageUp,
				domainCorrectYnCount: action.payload.domainCorrectYnCount,
				userSuggestDomain: action.payload.userSuggestDomain,
				memberConfirmedContacts: action.payload.memberConfirmedContacts,
				loading: false,
			}
		case GET_CONTACTS_DETAIL_LIST:
			return {
				...state,
				loading: true,
			}
		case GET_CONTACTS_DETAIL_LIST_SUCCESS:
			return {
				...state,
				contactsDetails: action.payload.contactsDetails,
				loading: false,
			}
		case GET_CONTACTS_MEMO:
			return {
				...state,
				loading: true,
			}
		case GET_CONTACTS_MEMO_SUCCESS:
			return {
				...state,
				memo: action.payload.memo,
				loading: false,
			}
		case CHANGE_CONTACTS_DETAILS:
			return {
				...state,
				contactsDetails: action.payload,
			}
		case SAVE_MEMO:
			return {
				...state,
			}
		case SAVE_MEMO_SUCCESS:
			return {
				...state,
				showSuccessAddToastFlag: true,
				toastMessage: "Saved memo!"
			}
		case CHANGE_IMPORTED_CONTACTS:
			return {
				...state,
				importedContacts: action.payload,
			}
		case CHANGE_SUGGESTED_CONTACTS:
			return {
				...state,
				suggestedContactsActive: action.payload,
			}
		case CHANGE_MEMBER_CONFIRMED_CONTACTS:
			return {
				...state,
				memberConfirmedContacts: action.payload,
			}
		case GET_CONTACTS_SETTINGS:
			return {
				...state,
				loading: true,
			}
		case GET_CONTACTS_SETTINGS_SUCCESS:
			return {
				...state,
				loading: false,
				searchSettings: action.payload.searchSettings,
				userGrade: action.payload.userGrade
			}
		case DOWN_CONTACTS_EXCEL:
			return {
				...state,
				loading: true,
			}
		case DOWN_CONTACTS_EXCEL_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case SET_SEARCH_SETTINGS:
			return {
				...state,
				searchSettings: action.payload
			}
		case SET_CONTACS_RESULT:
			return {
				...state,
				result: action.payload
			}
		case SET_CONTACS_DETAIL_RESULT:
			return {
				...state,
				detailResult: action.payload
			}
		case SET_CONTACS_LOADING:
			console.log(action.payload)
			if (action.payload === 'SEARCH_LOADING') {
				return {
					...state,
					contactSearchLoading: !state.contactSearchLoading ,
				}
			} 

			return {
				...state,
				loading: !state.loading ,
			}
		case GET_UPLOADED_CONTACTS_LIST:
			return {
				...state,
				loading: true
			}
		case GET_UPLOADED_CONTACTS_LIST_SUCCESS:
			return {
				...state,
				uploadedContactsList: action.payload.uploadedContactsList,
				uploadContactsHistory: action.payload.uploadHistory ? action.payload.uploadHistory : state.uploadContactsHistory,
				totalPageUp: action.payload.totalPageUp,
				noticeStrUp: action.payload.noticeStrUp,
				isSearched: true,
				loading: false
			}
		case SAVE_UPLOADED_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case DELETE_UPLOADED_CONTACTS:
			return {
				...state,
				loading: true,
			}
		case DELETE_UPLOADED_CONTACTS_BY_FILE:
			return {
				...state,
				loading: true,
			}
		case CHANGE_UPLOADED_CONTACTS_LIST:
			return {
				...state,
				uploadedContactsList: action.payload,
			}
		case DOWN_UPLOADED_CONTACTS_EXCEL:
			return {
				...state,
				loading: true,
			}
		case DOWN_UPLOADED_CONTACTS_EXCEL_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case GET_DOMAIN_CORRECT_YN_COUNT:
			return {
				...state,
				loading: true,
			}
		case GET_DOMAIN_CORRECT_YN_COUNT_SUCCESS:
			return {
				...state,
				domainCorrectYnCount: action.payload.domainCorrectYnCount,
				userSuggestDomain: action.payload.userSuggestDomain,
				loading: false
			}
		case SAVE_DOMAIN_CORRECT_YN:
			return {
				...state,
				loading: true,
			}
		case SAVE_DOMAIN_CORRECT_YN_SUCCESS:
			return {
				...state,
				domainCorrectYnCount: action.payload.domainCorrectYnCount,
				userSuggestDomain: action.payload.userSuggestDomain,
				loading: false
			}
		case CHANGE_USER_SUGGEST_DOMAIN:
			return {
				...state,
				userSuggestDomain: action.payload
			}
		case CHANGE_SHOW_SUCCESS_ADD_TOAST_FLAG:
			return {
				...state,
				showSuccessAddToastFlag: action.payload
			}
		case CHANGE_CHECK_UNSUBS_EMAIL_ADDRESS_FLAG:
			return {
				...state,
				checkUnsubsEmailAddressFlag: action.payload
			}
		case GET_CONTACT_SEARCH_LIST:
			return {
				...state,
				contactSearchLoading: true
			}
		case GET_CONTACT_SEARCH_LIST_SUCCESS:
			return {
				...state,
				searchList: action.payload.contactsList ? action.payload.contactsList : [],
				totalPageSearch: action.payload.totalPage,
				contactSearchLoading: false
			}
		case CHANGE_CONTACT_SEARCH_LIST:
			return {
				...state,
				searchList: action.payload,
			}
		case DOWN_SEARCH_ENTITY_EXCEL:
			return {
				...state,
				loading: true,
			}
		case DOWN_SEARCH_ENTITY_EXCEL_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case DISABLE_CONTACTS_SEND_YN:
			return {
				...state,
				loading: true,
			}
		case ENABLE_CONTACTS_SEND_YN:
			return {
				...state,
				loading: true,
			}
		default:
			return {
				...state,
			}
	}
}

function normalize(str) {
	const diacriticsNormalized = Diacritics.clean(str)
	return diacriticsNormalized
		?.toLowerCase()
		.replace(/-/g, " ") // replace hyphens with spaces
		.replace(/[^\w\s]/g, "") // remove punctuation
		// .replace(/\b(llc|ltd|inc|corp|company|firm|lp)\b/g, "") // remove suffixes
		.trim();
}

function tokenize(str) {
	const norimalized = normalize(str)
	return norimalized.split(/\s+/).filter(Boolean)
}

const isSimilar = (a, b) => {
  return a.includes(b) || b.includes(a);
};

export function rankSuggestedContacts(targetEntity, contacts) {
	// console.log(">>> rankSuggestedContacts: ", targetEntity, contacts)
	if (!contacts || contacts.length == 0) return [];
	const entityCountrys = targetEntity.country;
	const entityAddress = normalize(targetEntity.address);
	const entityTokens = tokenize(targetEntity.entityName);
	const entityField = targetEntity.field;

	const entityTokensWithInitials = normalize(targetEntity.entityName).split(" ");
	const initialTokens = entityTokensWithInitials.filter(token => token.length > 0 && token.length < 3)
	const oneLetterInitials = initialTokens.flatMap(i => i.split(""));

	// console.log("target entity: ", entityTokens, entityTokensWithInitials)
	// console.log("target entity initials: ", initialTokens, oneLetterInitials)

	function calculateScore(contact) {
		const { firstName, lastName, country, office, ipType, scrapeType } = contact
		const fnameTokens = tokenize(normalize(firstName))
		const lnameTokens = tokenize(normalize(lastName))

		// console.log(fnameTokens, lnameTokens)

		const firstMatchTokensCount = entityTokens.filter(token => fnameTokens.includes(token)).length;
		const lastMatchTokensCount = entityTokens.filter(token => lnameTokens.includes(token)).length;

		const firstFuzzyMatchTokensCount = entityTokens.filter(token =>
			fnameTokens.some(f => isSimilar(token, f))
		).length;

		const lastFuzzyMatchTokensCount = entityTokens.filter(token =>
			lnameTokens.some(f => isSimilar(token, f))
		).length;
		
		if (firstMatchTokensCount === entityTokens.length) {
			// console.log(1)
			return { showBulb: true, isNameMatched: true }
		}
		if (lastMatchTokensCount === entityTokens.length) {
			// console.log(2)
			return { showBulb: true, isNameMatched: true }
		}
		if (firstMatchTokensCount > 0 && lastMatchTokensCount > 0) {
			// console.log(3)
			return { showBulb: true, isNameMatched: true }
		}

		if (firstFuzzyMatchTokensCount === entityTokens.length) {
			// console.log(11)
			return { isFuzzyMatched: true }
		}
		if (lastFuzzyMatchTokensCount === entityTokens.length) {
			// console.log(12)
			return { isFuzzyMatched: true }
		}
		if (firstFuzzyMatchTokensCount > 0 && lastFuzzyMatchTokensCount > 0) {
			// console.log(13)
			return { isFuzzyMatched: true }
		}

		if (oneLetterInitials.length > 0 && (firstMatchTokensCount > 0 || lastMatchTokensCount > 0)) {
			let fnameMatchedTokens = 0
			let lnameMatchedTokens = 0
			oneLetterInitials.map((letter) => {
				fnameMatchedTokens += fnameTokens.filter(t => t.startsWith(letter)).length // 0 0
				lnameMatchedTokens += lnameTokens.filter(t => t.startsWith(letter)).length // 0 0
			})
			// console.log(8)

			if (lnameMatchedTokens > 0) {
				// console.log(6)
				return { isInitialMatched: true }
			} else if (fnameMatchedTokens > 0) {
				// console.log(7)
				return { isInitialMatched: true }
			}
			// console.log(8)
		}

		if (
			(country && country != "" && (entityCountrys.includes(country))) &&
			(office && office != "" && (entityAddress.includes(normalize(office))))
		) {
			// console.log(4)
			return { isCountryCityMatched: true }
		} else if (country && country != "" && (entityCountrys.includes(country))) {
			// console.log(13)
			return { isCountryOnlyMatched: true }
		} else if (office && office != "" && (entityAddress.includes(normalize(office)))) {
			// console.log(13)
			return { isCityOnlyMatched: true }
		}

		if (!(country || office) && ipType && entityField && ipType === entityField) {
			// console.log(9)
			return { isFieldMatch1: true }
		} else if (!(country || office) && ipType && entityField && ipType.includes(entityField) && ["Trademark & Design", "Trademark & Patent", "Patent & Design"].includes(ipType)) {
			// console.log(10)
			return { isFieldMatch2: true }
		} else if (!(country || office) && ipType && entityField && ipType.includes(entityField) && ipType === "Trademark, Design & Patent") {
			// console.log(11)
			return { isFieldMatch3: true }
		}

		if (entityField && entityField === "Patent" && scrapeType && scrapeType === "PCT") {
			// console.log(12)
			return { isPctScrapeTypeMatch: true }
		}

		// console.log(5)
		return { }

	}

	const withMatches = contacts
		?.map(contact => ({
			...contact,
			...calculateScore(contact)
		}))

	// console.table(withMatches)

	const nameMatched = []
	const initialMatched = []
	const fuzzyMatched = []
	const countryCityMatched = []
	const countryOnlyMatched = []
	const cityOnlyMatched = []
	const fieldMatched1 = []
	const fieldMatched2 = []
	const fieldMatched3 = []
	const pctScrapeTypeMatched = []
	const unMatched = []

	withMatches.map(con => {
		if (con.isNameMatched) nameMatched.push(con)
		else if (con.isInitialMatched) initialMatched.push(con)
		else if (con.isFuzzyMatched) fuzzyMatched.push(con)
		else if (con.isCountryCityMatched) countryCityMatched.push(con)
		else if (con.isCountryOnlyMatched) countryOnlyMatched.push(con)
		else if (con.isCityOnlyMatched) cityOnlyMatched.push(con)
		else if (con.isFieldMatch1) fieldMatched1.push(con)
		else if (con.isFieldMatch2) fieldMatched2.push(con)
		else if (con.isFieldMatch3) fieldMatched3.push(con)
		else if (con.isPctScrapeTypeMatch) pctScrapeTypeMatched.push(con)
		else unMatched.push(con)
	})

	if (nameMatched.length == 0 && fuzzyMatched.length > 0) {
		fuzzyMatched.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && fuzzyMatched.length == 0 && initialMatched.length > 0) {
		initialMatched.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && initialMatched.length == 0 && countryCityMatched.length > 0) {
		if (entityField === "Trademark" || entityField === "Design" || entityField === "Patent") {
			countryCityMatched.forEach(i => i.showBulb = true)
		} else {
			countryCityMatched.forEach(i => i.showBulb = true)
			countryOnlyMatched.forEach(i => i.showBulb = true)
			cityOnlyMatched.forEach(i => i.showBulb = true)
		}
	} 
	else if (nameMatched.length == 0 && countryCityMatched.length == 0 && (countryOnlyMatched.length > 0 || cityOnlyMatched.length > 0)) {
		countryOnlyMatched.forEach(i => i.showBulb = true)
		cityOnlyMatched.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && countryOnlyMatched.length == 0 && cityOnlyMatched.length == 0 && fieldMatched1.length > 0) {
		fieldMatched1.forEach(i => i.showBulb = true)
		pctScrapeTypeMatched.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && fieldMatched1.length == 0 && pctScrapeTypeMatched.length > 0) {
		pctScrapeTypeMatched.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && pctScrapeTypeMatched.length == 0 && fieldMatched2.length > 0) {
		fieldMatched2.forEach(i => i.showBulb = true)
	} 
	else if (nameMatched.length == 0 && fieldMatched2.length == 0 && fieldMatched3.length > 0) {
		fieldMatched3.forEach(i => i.showBulb = true)
	} 
	
	const final = [...nameMatched, ...fuzzyMatched, ...initialMatched, ...countryCityMatched, ...countryOnlyMatched, ...cityOnlyMatched, ...fieldMatched1, ...pctScrapeTypeMatched, ...fieldMatched2, ...fieldMatched3, ...unMatched]
	// console.table(final)

	return final;
}

export default contacts
